<template>
  <el-collapse v-model="activePanes">
    <el-collapse-item name="form" :title="$t('ImportMapItem.title')">
      <el-card class="box-card mb-10" header="">
        <div class="text item">
          <el-form
            label-position="top"
            :rules="rules"
            ref="form"
            :model="mapModel"
            size="small"
            status-icon
          >
            <el-form-item :label="$t('ImportMapItem.mapname')" prop="name">
              <el-input
                v-model="mapModel.name"
                :placeholder="$t('ImportMapItem.mapname')"
              />
            </el-form-item>

            <el-form-item :label="$t('ImportMapItem.URL')" prop="url">
              <el-input
                v-model="mapModel.url"
                :placeholder="$t('ImportMapItem.mapURL')"
              />
            </el-form-item>

            <el-form-item :label="$t('ImportMapItem.mapType')" prop="mapType">
              <el-radio
                v-model="mapModel.mapType"
                :label="$t('ImportMapItem.XYZ')"
              ></el-radio>
              <el-radio
                v-model="mapModel.mapType"
                :label="$t('ImportMapItem.WMS')"
                >WMS</el-radio
              >
              <el-radio
                v-model="mapModel.mapType"
                :label="$t('ImportMapItem.WMTS')"
                >WMTS</el-radio
              >
            </el-form-item>

            <el-form-item>
              <el-alert
                title="测试成功!"
                type="success"
                :closable="false"
                v-if="canImport"
              />
              <el-alert
                title="不是有效的地址"
                type="error"
                :closable="false"
                v-if="testError"
              />
            </el-form-item>

            <div class="align-right">
              <el-button
                class="ml-10"
                :loading="testing"
                @click="testConnection"
              >
                {{ $t('ImportMapItem.testconnection') }}
              </el-button>
              <el-button
                class="ml-10"
                :disabled="!canImport"
                @click="importMap"
              >
                {{ $t('ImportMapItem.import') }}
              </el-button>
            </div>
          </el-form>
        </div>
      </el-card>
    </el-collapse-item>

    <el-collapse-item
      name="list"
      :title="$t('HistoryMapItem.historyconnections')"
    >
      <el-card class="box-card mb-10" v-if="maps.length > 0">
        <div class="text item">
          <history-map-item v-for="(map, i) in maps" :key="i" :map="map" />
        </div>
      </el-card>
      <el-empty
        :description="$t('DisplayedMap.nomaps')"
        v-else
        :image-size="80"
      />
    </el-collapse-item>
  </el-collapse>
</template>
<script>
import axios from 'axios';
import { mapState } from 'vuex';
import { resolveWMS } from '@/carto-node/models/wms';
import { resolveWMTS } from '@/carto-node/models/wmts';
import HistoryMapItem from '@/components/maps/HistoryMapItem';

import {
  useTrack,
  FunctionIdEnum,
  EventTypeEnum,
} from '@/components/sendMetrics';

const { track } = useTrack();

export default {
  components: { HistoryMapItem },
  data() {
    return {
      activePanes: ['form', 'list'],
      mapModel: {
        name: '',
        url: '',
        mapType: 'XYZ',
      },
      canImport: false,
      testing: false,
      testError: null,
      rules: {
        name: [
          {
            required: true,
            message: 'Please input Map name',
            trigger: 'change',
          },
        ],
        url: [
          {
            required: true,
            message: 'Please input Map url',
            trigger: 'change',
          },
        ],
      },
    };
  },
  computed: {
    ...mapState('importMaps', {
      maps: (state) => state.list,
    }),
    templateUrl() {
      if (this.mapModel.mapType === 'XYZ') {
        const subdomains = ['a', 'b', 'c'];
        const url = this.mapModel.url
          .replace(/\{s\}/g, () => subdomains[Math.floor(Math.random() * 3)])
          .replace(/\{x\}/g, '0')
          .replace(/\{y\}/g, '0')
          .replace(/\{z\}/g, '0');
        return url;
      }
      return this.mapModel.url;
    },
  },
  methods: {
    async importMap() {
      let model = null;
      if (this.mapModel.mapType === 'XYZ') {
        model = this.mapModel;
      } else if (this.mapModel.mapType === 'WMS') {
        const wms = await resolveWMS(this.mapModel.url);
        model = { ...this.mapModel, wms };
      } else {
        const wmts = await resolveWMTS(this.mapModel.url);
        model = { ...this.mapModel, wmts };
      }
      if (model) {
        model.id = model.name;
        model.visible = true;
        this.$store.dispatch('importMaps/importMap', model);
        this.canImport = false;

        track(
          FunctionIdEnum.globalLayer_layers_importFromUrl,
          EventTypeEnum.CLICK,
          {
            layerName: this.mapModel.name,
            url: this.mapModel.url,
            layerType: this.mapModel.mapType,
          },
        );
      }
    },
    async testConnection() {
      this.testing = true;
      this.canImport = false;
      this.testError = false;
      let isValid = false;
      this.$refs.form.clearValidate();
      await this.$refs.form.validate((valid) => (isValid = valid));
      if (!isValid) {
        this.testing = false;
        this.canImport = false;
        this.testError = true;
        return;
      }
      try {
        await axios({
          method: 'get',
          baseURL: '',
          url: this.templateUrl,
        });
        this.canImport = true;

        track(
          FunctionIdEnum.globalLayer_layers_testConnection,
          EventTypeEnum.CLICK,
          {
            layerName: this.mapModel.name,
            url: this.mapModel.url,
            layerType: this.mapModel.mapType,
          },
        );
      } catch (err) {
        this.canImport = false;
        this.testError = true;
      } finally {
        this.testing = false;
      }
    },
  },
};
</script>
<style scoped>
.mb-10 {
  margin-bottom: 10px;
}

.ml-10 {
  margin-left: 10px;
}

.title {
  text-align: left;
}

.carto-btn {
  background: #fc4c02;
  color: #fff;
}
</style>
